/* MOG MINTS — behaviour for the index template.
   Lifted verbatim from the page-level script in index.html at the port, 23 Aug.
   Only two things changed: the mint-sequence frame path (Shopify assets are
   flat, so assets/mint/seq/ became a 'mintseq-' prefix and the base URL is
   injected by Liquid), and other asset paths flattened the same way.

   ⚠ Every module in here guards on its own root element, so loading it on a
   page that lacks that markup is a no-op rather than an error. */
/* ---- the buy module ------------------------------------------------------
   NOT ONE FIGURE IN HERE IS CALCULATED. This block used to hold BASE, BUNDLE
   and SUB and derive every price on the page from them, which is how two files
   ended up holding one price. On Shopify that job belongs to variants and
   selling plans, so the arithmetic is gone and what remains is a renderer: it
   reads the table Liquid wrote into [data-buy-data] and puts those strings on
   screen. The markup and the class toggles are untouched, per the porting note
   that used to sit here.

   Money arrives already formatted by the `money` filter, so currency format
   stays a store setting and this file never sees a number it could round.

   THE SUBSCRIBE PRICE IS THE PLAN'S OWN ALLOCATION PRICE. If a rendered
   subscribe price disagrees with the agreed table, the subscription app is
   configured wrong. Do not correct it here.

   ⚠ The cart field is found BY NAME, never by id. Setting it through the
   subscription app's own DOM nodes is known to break. */
(function(){
  /* 2026-10-14 (decision 129, "Yes, match the home page"): the home page's buy section is product-buy, the product page's
     variant D, and no template renders the .prod card any more (sections/index-buy.liquid stays in the theme, unused). So
     this module finds no .prod and returns at its first line; the new card's prices, hidden id and selling plan are
     product.js's, which the layout loads on the home page after this file. */
  var root = document.querySelector('.prod'); if (!root) return;
  var tag  = root.querySelector('[data-buy-data]'); if (!tag) return;
  var DATA; try { DATA = JSON.parse(tag.textContent); } catch (e) { return; }
  if (!DATA || !DATA.variants || !DATA.variants.length) return;

  var byId = {};
  DATA.variants.forEach(function(v){ byId[String(v.id)] = v; });

  /* mirrored figures live outside .prod too (closing block, sticky bar) */
  var setAll = function(sel, txt){
    [].forEach.call(document.querySelectorAll(sel), function(el){ el.textContent = txt; });
  };
  var set = function(sel, txt){
    var el = root.querySelector(sel); if (el) el.textContent = txt;
  };
  function esc(s){
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cadenceOf(name){
    var l = String(name == null ? '' : name), i = l.toLowerCase().indexOf('every');
    return i < 0 ? l : 'Every ' + l.slice(i + 5).split('(')[0].trim();
  }
  /* the plan's cadence inside a sentence: "Deliver every 1 month" reads "every month", "every 2 months" stays */
  function everyOf(name){
    var l = String(name == null ? '' : name).toLowerCase(), i = l.indexOf('every');
    if (i < 0) return 'per delivery';
    return 'every ' + l.slice(i + 5).split('(')[0].trim().replace(/^1\s+/, '');
  }
  function read(name){
    var el = root.querySelector('input[name="' + name + '"]:checked');
    return el ? el.value : null;
  }
  /* the cadence is a select since 2026-10-07 (Ashot's spec: "choose delivery frequency"); the radios it
     replaced are still read, so an older card keeps working */
  function freq(){
    var s = root.querySelector('select[name="pfreq"]');
    return s ? s.value : read('pfreq');
  }
  function currentVariant(){
    var id = read('size');
    return (id && byId[id]) || DATA.variants[0];
  }
  /* the chosen cadence, or the first plan the variant offers. A variant with no
     plans returns null and every subscribe branch below goes quiet. */
  function planFor(v){
    if (!v || !v.plans || !v.plans.length) return null;
    var want = freq();
    for (var i = 0; i < v.plans.length; i++){
      if (String(v.plans[i].id) === String(want)) return v.plans[i];
    }
    return v.plans[0];
  }
  /* the frequency options follow the pack. The plans are the store's and shared across sizes, so the ids
     match and the choice survives a size change; a size with fewer plans simply offers fewer. */
  function options(v){
    var s = root.querySelector('select[name="pfreq"]'); if (!s) return;
    var keep = s.value, html = '';
    (v.plans || []).forEach(function(p){
      html += '<option value="' + esc(p.id) + '"' + (String(p.id) === String(keep) ? ' selected' : '') + '>' + esc(p.name) + '</option>';
    });
    if (s.innerHTML !== html) s.innerHTML = html;
  }

  function render(){
    var v = currentVariant(); if (!v) return;
    options(v);
    var sub  = read('ptype') === 'sub';
    var plan = planFor(v);
    /* A SIZE WITH NO PLAN (the 240 pack today, 2026-09-15): the subscribe row and its panel go
       and One time takes the selection, instead of a row with an empty price. */
    var noPlan = !plan;
    root.classList.toggle('no-plans', noPlan);
    if (noPlan && sub) {
      var onceIn = root.querySelector('input[name="ptype"][value="once"]');
      if (onceIn) { onceIn.checked = true; }
      sub = false;
    }
    var now  = (sub && plan) ? plan.price : v.price;

    setAll('[data-total]', now);
    /* the price rides on the Add to cart button (Ashot's mockup, 2026-10-07) */
    setAll('[data-cart]', '• ' + now);
    /* per-mint is the variant's own, so it can never drift from the price above it */
    if (v.each > 0) setAll('[data-each]', v.each + '¢ a mint');
    /* guarded: the spec grid states 60 mints PER TIN, which does not move with
       quantity, so there may be no [data-count] on the page at all. Unguarded
       this throws and takes every price on the section down with it. */
    setAll('[data-count]', (v.tins * 60) + ' mints' + (v.tins > 1 ? ' · ' + v.tins + ' tins' : ''));

    /* the struck price is a REAL comparison every time: against the same order
       undiscounted when buying once, against the one-time price when
       subscribing. Empty when nothing is saved, and .save:empty plus this blank
       string keep the flags off the page entirely. */
    set('[data-was]', sub && plan ? v.price : (v.compare || ''));
    set('[data-subsave]', plan && plan.pct > 0 ? 'Save ' + plan.pct + '%' : '');
    setAll('[data-subpct]', plan ? plan.pct + '%' : '');

    /* the two purchase rows always quote the CURRENT pack, so switching to
       subscribe compares like with like instead of against a single tin */
    set('[data-ponce]', v.price);
    setAll('[data-hprice]', v.price);
    setAll('[data-hwas]', v.compare || '');
    set('[data-psub]',  plan ? plan.price : '');
    setAll('[data-was-sub]', v.price);

    /* THE SUBSCRIPTION LINES (2026-10-07, Ashot's spec). The deal pack's plan carries the renewal price
       of the smaller pack it becomes (Liquid looked it up from settings.sub_renew_tins); every other
       pack renews as itself. The words follow: "today" against "per delivery", and "on your first order"
       only where a renewal differs. Nothing here is a number the page did not already hold. */
    var renew = !!(plan && plan.renew && DATA.renew_tins > 0);
    set('[data-psub-when]', renew ? 'today' : 'per delivery');
    var rn = root.querySelector('[data-sub-renew]');
    if (rn) {
      rn.hidden = !renew;
      /* one sentence since 2026-10-09, Ashot's words ("3 tins on the first order, then 2 tins for ... every month"),
         the same one the Liquid prints; the price is the renewal pack's own plan price, read, never typed */
      if (renew) {
        set('[data-sub-line]', v.tins + (v.tins === 1 ? ' tin' : ' tins') + ' on the first order, then ' + DATA.renew_tins +
          (DATA.renew_tins === 1 ? ' tin' : ' tins') + ' for ' + plan.renew + ' ' + everyOf(plan.name));
      }
    }
    /* the cadence, printed from the plan's name the way the Liquid prints it ("Deliver every 1 month" reads "Every 1 month") */
    var cad = root.querySelector('[data-cadence]');
    if (cad && plan) cad.textContent = cadenceOf(plan.name);

    /* THE VARIANT FIELD (2026-09-30). One hidden input[name="id"], kept in step with the checked size.
       The size cards used to BE the id field, four radios sharing the name. The add to cart post was
       fine with that, a browser serialises the checked one. Shopify's wallet script is not:
       portable-wallets reads form.elements.namedItem("id") and, handed a radio group, takes .item(0),
       the first radio, always. So Apple Pay and Shop Pay on the product page sold the Solo whatever
       size was chosen, and a customer caught it. The wallet re-reads the form when a value ATTRIBUTE
       changes (its MutationObserver filters on "value"), so the attribute is set with the property.
       The home card has no form and no such field, and this block is a no-op there. */
    var idIn = root.querySelector('input[type="hidden"][name="id"]');
    if (idIn && idIn.value !== String(v.id)) {
      idIn.value = String(v.id);
      idIn.setAttribute('value', String(v.id));
      idIn.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* THE CART FIELD. By name, always. */
    var sp = root.querySelector('[name="selling_plan"]');
    if (sp) sp.value = (sub && plan) ? plan.id : '';
  }

  root.addEventListener('change', function(e){
    if (e.target.name === 'size' || e.target.name === 'ptype') render();
    /* reaching for a cadence IS choosing to subscribe. Without this you can set
       "every 2 months" while One-time stays selected, and the box argues with
       itself. */
    if (e.target.name === 'pfreq') {
      var s = root.querySelector('input[name="ptype"][value="sub"]');
      if (s && !s.checked) { s.checked = true; }
      render();
    }
  });

  /* ADD TO CART. The home page's control is an anchor to the product page, which
     is a working route with scripting off; here we intercept it and post to the
     cart instead. The product page's control is a real submit inside
     {% form 'product' %} and needs no help, so it is left alone unless the
     drawer is present to catch it. */
  var addLink = root.querySelector('[data-add]');
  if (addLink) {
    addLink.addEventListener('click', function(ev){
      var v = currentVariant(); if (!v) return;   /* no sold-out gate in the theme (2026-09-14) */
      ev.preventDefault();
      var body = { items: [{ id: v.id, quantity: 1 }] };
      var sp = root.querySelector('[name="selling_plan"]');
      if (sp && sp.value) body.items[0].selling_plan = Number(sp.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        /* never report a success we did not get: a non-2xx here is a real
           failure and the reader has to end up somewhere that works. */
        if (!r.ok) { window.location.href = addLink.getAttribute('href'); return null; }
        return r.json();
      }).then(function(data){
        if (!data) return;
        document.dispatchEvent(new CustomEvent('mog:cart:added', { detail: data }));
      }).catch(function(){
        window.location.href = addLink.getAttribute('href');
      });
    });
  }

  render();
})();

/* The four systems. A real tablist: click, and arrow/Home/End keys move between
   systems with roving tabindex, because a row of <button role="tab"> that only
   answers the mouse is a tablist in name only. */
(function(){
  var nav = document.querySelector('.sysnav'); if(!nav) return;
  var tabs = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.pane'));

  function show(sys, focus){
    tabs.forEach(function(t){
      var on = t.dataset.sys === sys;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.sys === sys;
      p.hidden = !on;
      /* Restart the entrance AND every diagram animation inside the pane.
         The panes are stacked in one grid cell and hidden with visibility, so
         they never leave the render tree — which means their animations do NOT
         restart on their own the way they did under display:none.
         Dropping the pane out of the render tree for one frame and putting it
         straight back cancels and re-starts the whole subtree. Toggling
         p.style.animation only ever restarted the pane's own entrance, not the
         curves, the climbing ball or the gears.
         The container does not flinch while this happens: the other three panes
         are still laid out in the same cell holding the height, and no paint
         occurs inside a single task. */
      if (on){ p.style.display = 'none'; void p.offsetWidth; p.style.display = ''; }
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.sys); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.sys, true);
  });
})();

/* ---- GALLERY-JS-START ---- the product gallery. Same tablist contract as the
   question groups below. The build cuts on these markers to lift it onto
   shop.html, so the two pages cannot end up with different gallery behaviour. */
(function(){
  var wrap = document.getElementById('stage'); if(!wrap) return;
  var shots = [].slice.call(wrap.children);
  var tabs  = [].slice.call(document.querySelectorAll('.stage__rail button'));
  var n     = document.getElementById('stage-n');
  function show(i, focus){
    shots.forEach(function(s, k){ s.hidden = k !== i; });
    tabs.forEach(function(t, k){
      t.setAttribute('aria-current', k === i ? 'true' : 'false');
      if (k === i && focus) t.focus();
    });
    if (n) n.textContent = ('0' + (i + 1)).slice(-2);
  }
  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(+t.dataset.go); });
  });
  document.querySelector('.stage__rail').addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement); if (i < 0) return;
    var k = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') k = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') k = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') k = 0;
    else if (e.key === 'End') k = tabs.length - 1;
    if (k === null) return;
    e.preventDefault(); show(k, true);
  });
})();
/* ---- GALLERY-JS-END ---- */

/* The question groups. Same tablist contract as the four systems — the two could
   share a factory, and if a third tablist ever lands on this page they should.
   Two are not enough to justify the indirection; three would be. */
(function(){
  var nav = document.querySelector('.faq__nav'); if(!nav) return;
  /* ONE BINDING PER TABLIST (2026-10-14). product.js carries this module twice, and since the home page's buy section became
     product-buy (decision 129) the home page loads product.js beside this file, so the FAQ's tablist was bound twice on the
     product page and three times on the home page. Every binding answers the same arrow key in turn, so one press moved the
     choice two tabs on the product page and all the way round to where it started on the home page (measured on the local
     faithful pages). Whichever copy runs first binds the tablist and marks it; every later copy stands down. */
  if (nav.hasAttribute('data-tabs-bound')) return; nav.setAttribute('data-tabs-bound', '');
  var tabs  = [].slice.call(nav.querySelectorAll('[role="tab"]'));
  var panes = [].slice.call(document.querySelectorAll('.faq__grp'));

  function show(key, focus){
    tabs.forEach(function(t){
      var on = t.dataset.faq === key;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    panes.forEach(function(p){
      var on = p.dataset.faq === key;
      p.hidden = !on;
      /* leave the panel you are switching away from closed up. Coming back to a
         group and finding a panel you opened five minutes ago still hanging open
         reads as a bug, and it makes the two panes different heights. */
      if (!on) [].forEach.call(p.querySelectorAll('details[open]'), function(d){ d.open = false; });
    });
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.dataset.faq); });
  });

  nav.addEventListener('keydown', function(e){
    var i = tabs.indexOf(document.activeElement);
    if (i < 0) return;
    var n = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') n = 0;
    else if (e.key === 'End') n = tabs.length - 1;
    if (n === null) return;
    e.preventDefault();
    show(tabs[n].dataset.faq, true);
  });
})();

/* The testimonial carousel moved to assets/proof-rail.js on 2026-09-16 and is loaded by
   sections/index-proof.liquid itself, because that section also renders on the product page and
   this file is routed for the home page only. Do not re-add it here. */
